import script from "./MiniBasket.vue?vue&type=script&setup=true&lang=js"
export * from "./MiniBasket.vue?vue&type=script&setup=true&lang=js"

import "./MiniBasket.vue?vue&type=style&index=0&id=4043e3f1&lang=css"

const __exports__ = script;

export default __exports__